import React from 'react';
import styled from 'styled-components';
import { Spinner } from 'spinner';

import SidebarCard from './SidebarCard';

const Name = styled.header`
  font-size: 16px;
`;

const Details = styled.div`
  padding-top: 8px;
  font-size: 14px;
`;

const SpinnerWrap = styled.div`
  padding: 16px 0;
  text-align: center;
`;

type LedgerInfoCardProps = {
  name: string;
  details: string;
  loading: boolean;
  error: string;
};

const LedgerInfoCard = ({ name, details, loading, error }: LedgerInfoCardProps) => (
  <SidebarCard>
    {name && <Name>{name}</Name>}
    {details && <Details>{details}</Details>}
    {loading && (
      <SpinnerWrap>
        <Spinner />
      </SpinnerWrap>
    )}
    {error && <Details>{error}</Details>}
  </SidebarCard>
);

LedgerInfoCard.defaultProps = {
  name: '',
  details: '',
};

export default LedgerInfoCard;
